var _rect, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoinPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.405273,
    width: 41.2859,
    height: 41.1899,
    rx: 18.3003,
    fill: "#31B7A9",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.33333,
    transform: "matrix(-1 0 0 1 18.9792 16.8333)",
    fill: "#31B7A9",
    stroke: "#31B7A9",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1445 25.1119C13.1445 24.3949 13.5952 23.7554 14.2704 23.5142C17.3146 22.427 20.6412 22.427 23.6853 23.5142C24.3605 23.7554 24.8112 24.3949 24.8112 25.1119V26.2082C24.8112 27.1977 23.9348 27.9578 22.9552 27.8179L22.1598 27.7042C20.0492 27.4027 17.9065 27.4027 15.7959 27.7042L15.0005 27.8179C14.021 27.9578 13.1445 27.1977 13.1445 26.2082V25.1119Z",
    fill: "#31B7A9",
    stroke: "#31B7A9",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8112 20.167H28.1445",
    stroke: "#31B7A9",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4766 18.4997L26.4766 21.833",
    stroke: "#31B7A9",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinPartners);
export default __webpack_public_path__ + "static/media/join-partners.6782854706c7e438a5dea79c4f47d869.svg";
export { ForwardRef as ReactComponent };